import React from "react";

import { cn } from "@/lib/utils";

/* Applies the standard spacing values to content blocks.
 * Should wrap the Container component (./container.tsx) to apply the grid.
 *
 * Default spacing: x-large (pt-12 pb-12 md:pt-16 md:pb-16)
 * Override via className with Tailwind padding utilities.
 */
export const Section = React.forwardRef<
  HTMLElement,
  React.HTMLAttributes<HTMLElement>
>(({ className, children, ...props }, ref) => (
  <section
    ref={ref}
    className={cn("px-4 py-12 md:py-16 lg:px-8", className)}
    {...props}
  >
    {children}
  </section>
));

Section.displayName = "Section";
